import ENV from 'env';

export default class MysolvrEntryDetailController {
  constructor($sce, $stateParams) {
    'ngInject';

    this.$sce = $sce;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.mysolvrEntry.url = `${ENV.mysolvrUrl}/#/${this.$stateParams.filter}/${this.$stateParams.mysolvrEntryId}`;
  }

  humanizeAttrName(attributeName) {
    if (attributeName) {
      const humanizedName = attributeName.charAt(0).toUpperCase() + attributeName.slice(1);
      return humanizedName.replace(/_/g, ' ');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/mysolvr-entries/screens/mysolvr-entry-detail/mysolvr-entry-detail.controller.js